<template lang="pug">
  div
    .ai-manuscript-modal(:class="{ open: showAi }")
      a.ai-manuscript-modal-close(@click="close")
        | 閉じる
      .ai-manuscript-modal-title
        | AI原稿生成
      .ai-manuscript-modal-main
        .button-check-group
          .button-check-area(v-if="isLoading")
            input.button-check.disabled(type="button" value="原稿生成中・・・" :disabled="true")
          .button-check-area(v-else)
            input.button-check(type="button" value="原稿生成" @click="generateAiManuscript")
          .button-check-area
            input.button-check.csv(type="button" value="CSVダウンロード" @click="downloadCSV")
      .ai-manuscript-modal-body
        p 仕事No
        input.text-box(type="text" v-model="jobDetail.job_id")
        p 業務名
        input.text-box(type="text" v-model="jobDetail.jobtype_name")
        p 業務名補足
        input.text-box(type="text" v-model="jobDetail.jobname_detail")
        p 働く場所(表示用)
        input.text-box(type="text" v-model="jobDetail.work_place")
        p 募集1_雇用形態
        input.text-box(type="text" v-model="jobDetail.employment_name")
        p 募集1_給与下限
        input.text-box(type="text" v-model="jobDetail.salary_min")
        p 募集1_給与上限
        input.text-box(type="text" v-model="jobDetail.salary_max")
        p 募集1_固定残業制
        input.text-box(type="text" v-model="jobDetail.fixed_overtime")
        p 募集1_勤務開始時間1
        input.text-box(type="text" v-model="jobDetail.shift1_start")
        p 募集1_勤務終了時間1
        input.text-box(type="text" v-model="jobDetail.shift1_end")
        p 給与備考
        input.text-box(type="text" v-model="jobDetail.salary_detail")
        p 勤務時間帯フラグ_早朝
        input.text-box(type="text" v-model="jobDetail.flag_early_morning")
        p 勤務時間帯フラグ_朝
        input.text-box(type="text" v-model="jobDetail.flag_morning")
        p 勤務時間帯フラグ_昼
        input.text-box(type="text" v-model="jobDetail.flag_daytime")
        p 勤務時間帯フラグ_夕
        input.text-box(type="text" v-model="jobDetail.flag_evening")
        p 勤務時間帯フラグ_夜
        input.text-box(type="text" v-model="jobDetail.flag_night")
        p 勤務時間帯フラグ_深夜
        input.text-box(type="text" v-model="jobDetail.flag_midnight")
        p 勤務時間備考
        input.text-box(type="text" v-model="jobDetail.shift_notes")
        p 採用予定人数
        input.text-box(type="text" v-model="jobDetail.recruits")
        p アピールポイント_タイトル
        input.text-box(type="text" v-model="jobDetail.appeal_point_title")
        p アピールポイント_内容
        input.text-box(type="text" v-model="jobDetail.appeal_point_content")
        p 仕事内容
        input.text-box(type="text" v-model="jobDetail.job_contents")
        p 経験・資格
        input.text-box(type="text" v-model="jobDetail.requestment")
        p 休日・休暇(日曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_sunday")
        p 休日・休暇(月曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_monday")
        p 休日・休暇(火曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_tuesday")
        p 休日・休暇(水曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_wednesday")
        p 休日・休暇(木曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_thursday")
        p 休日・休暇(金曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_friday")
        p 休日・休暇(土曜日)
        input.text-box(type="text" v-model="jobDetail.holiday_saturday")
        p 休日・休暇(祝日)
        input.text-box(type="text" v-model="jobDetail.holiday_holiday")
        p 休日・休暇(完全週休2日)
        input.text-box(type="text" v-model="jobDetail.holiday_full_weekend")
        p 休日・休暇(交代制)
        input.text-box(type="text" v-model="jobDetail.holiday_shift")
        p 休日・休暇備考
        input.text-box(type="text" v-model="jobDetail.holiday_notes")
        p 勤務期間備考
        input.text-box(type="text" v-model="jobDetail.working_period_notes")
        p 社員登用あり
        input.text-box(type="text" v-model="jobDetail.employee_promotion_available")
        p シフト自由・相談OK
        input.text-box(type="text" v-model="jobDetail.flexible_shift")
        p シフト提出(月毎)
        input.text-box(type="text" v-model="jobDetail.shift_submission_monthly")
        p シフト提出(1~2週毎)
        input.text-box(type="text" v-model="jobDetail.shift_submission_biweekly")
        p 週1日からOK
        input.text-box(type="text" v-model="jobDetail.one_day_per_week_ok")
        p 週2〜3日からOK
        input.text-box(type="text" v-model="jobDetail.two_to_three_days_per_week_ok")
        p 週4日以上OK
        input.text-box(type="text" v-model="jobDetail.four_or_more_days_per_week_ok")
        p 1日1・2時間以内OK
        input.text-box(type="text" v-model="jobDetail.one_to_two_hours_per_day_ok")
        p 1日4時間以内(短時間)OK
        input.text-box(type="text" v-model="jobDetail.up_to_four_hours_per_day_ok")
        p 1日6時間以内OK
        input.text-box(type="text" v-model="jobDetail.up_to_six_hours_per_day_ok")
        p 9時以降勤務開始OK
        input.text-box(type="text" v-model="jobDetail.start_after_9am")
        p 10時以降勤務開始OK
        input.text-box(type="text" v-model="jobDetail.start_after_10am")
        p 16時前退社OK
        input.text-box(type="text" v-model="jobDetail.leave_before_4pm")
        p 17時前退社OK
        input.text-box(type="text" v-model="jobDetail.leave_before_5pm")
        p 土日祝休み
        input.text-box(type="text" v-model="jobDetail.weekends_holidays_off")
        p 土日祝(週末)のみOK
        input.text-box(type="text" v-model="jobDetail.weekends_only_ok")
        p 完全週休二日制
        input.text-box(type="text" v-model="jobDetail.full_two_day_off")
        p 家庭や子供の用事でお休み調整可
        input.text-box(type="text" v-model="jobDetail.family_responsibilities_flexible")
        p 春休み・夏休み・冬休み期間限定
        input.text-box(type="text" v-model="jobDetail.seasonal_holiday_only")
        p 残業なし
        input.text-box(type="text" v-model="jobDetail.no_overtime")
        p 残業少なめ(月20時間未満)
        input.text-box(type="text" v-model="jobDetail.low_overtime")
        p 残業多め(月20時間以上)
        input.text-box(type="text" v-model="jobDetail.high_overtime")
        p 高収入・高額・高給
        input.text-box(type="text" v-model="jobDetail.high_income")
        p 在宅ワーク・内職
        input.text-box(type="text" v-model="jobDetail.remote_work")
        p 給与UP
        input.text-box(type="text" v-model="jobDetail.salary_increase")
        p 昇給あり
        input.text-box(type="text" v-model="jobDetail.salary_raise_available")
        p 未経験・初心者歓迎
        input.text-box(type="text" v-model="jobDetail.no_experience_required")
        p 主婦(ママ)・主夫歓迎
        input.text-box(type="text" v-model="jobDetail.housewives_househusbands_welcome")
        p 学生歓迎
        input.text-box(type="text" v-model="jobDetail.students_welcome")
        p 高校生歓迎
        input.text-box(type="text" v-model="jobDetail.highschool_students_welcome")
        p 新卒・第二新卒歓迎
        input.text-box(type="text" v-model="jobDetail.fresh_graduates_welcome")
        p フリーター歓迎
        input.text-box(type="text" v-model="jobDetail.freeters_welcome")
        p ミドル(40代〜)活躍中
        input.text-box(type="text" v-model="jobDetail.middle_aged_active")
        p シニア(60代〜)歓迎
        input.text-box(type="text" v-model="jobDetail.seniors_welcome")
        p 外国人活躍中・留学生歓迎
        input.text-box(type="text" v-model="jobDetail.foreigners_students_welcome")
        p 学歴(中卒・高卒)不問
        input.text-box(type="text" v-model="jobDetail.no_academic_requirement")
        p 副業・WワークOK_深夜
        input.text-box(type="text" v-model="jobDetail.side_job_ok")
        p ブランク有OK
        input.text-box(type="text" v-model="jobDetail.career_gap_ok")
        p 経験者優遇
        input.text-box(type="text" v-model="jobDetail.experienced_preferred")
        p オープニングスタッフ
        input.text-box(type="text" v-model="jobDetail.opening_staff")
        p 駅から徒歩5分以内
        input.text-box(type="text" v-model="jobDetail.station_within_5_minutes")
        p 産休・育休取得実績あり
        input.text-box(type="text" v-model="jobDetail.maternity_paternity_leave_available")
        p 交通費支給
        input.text-box(type="text" v-model="jobDetail.transportation_provided")
        p 寮・社宅あり(住み込み)
        input.text-box(type="text" v-model="jobDetail.dormitory_provided")
        p 託児所あり
        input.text-box(type="text" v-model="jobDetail.daycare_available")
        p 社会保険制度あり
        input.text-box(type="text" v-model="jobDetail.social_insurance")
        p まかない・食事補助
        input.text-box(type="text" v-model="jobDetail.meal_support")
        p 研修制度あり
        input.text-box(type="text" v-model="jobDetail.training_available")
        p 髪型・髪色自由
        input.text-box(type="text" v-model="jobDetail.free_hair_style")
        p 服装自由
        input.text-box(type="text" v-model="jobDetail.clothing_free")
        p 履歴書不要
        input.text-box(type="text" v-model="jobDetail.no_resume_required")
        p 友達と一緒に応募OK
        input.text-box(type="text" v-model="jobDetail.apply_with_friends_ok")
        p 正社員経験不問
        input.text-box(type="text" v-model="jobDetail.no_full_time_experience_required")
        p 職種未経験OK
        input.text-box(type="text" v-model="jobDetail.no_job_experience_required")
        p 資格・スキル身につく
        input.text-box(type="text" v-model="jobDetail.gain_qualification_skills")
        p 将来は独立
        input.text-box(type="text" v-model="jobDetail.future_independence")
        p 待遇福利厚生が充実
        input.text-box(type="text" v-model="jobDetail.excellent_benefits")
        p 女性活躍中
        input.text-box(type="text" v-model="jobDetail.women_active")
        p 職場環境_年齢層_10代
        input.text-box(type="text" v-model="jobDetail.age_group_teens")
        p 職場環境_年齢層_20代
        input.text-box(type="text" v-model="jobDetail.age_group_20s")
        p 職場環境_年齢層_30代
        input.text-box(type="text" v-model="jobDetail.age_group_30s")
        p 職場環境_年齢層_40代
        input.text-box(type="text" v-model="jobDetail.age_group_40s")
        p 職場環境_年齢層_50代
        input.text-box(type="text" v-model="jobDetail.age_group_50s")
        p 時間固定シフト制
        input.text-box(type="text" v-model="jobDetail.fixed_time_shift")
        p 日払いOK
        input.text-box(type="text" v-model="jobDetail.daily_pay_ok")
        p 週払いOK
        input.text-box(type="text" v-model="jobDetail.weekly_pay_ok")
        p エルダー(50代〜)活躍中
        input.text-box(type="text" v-model="jobDetail.elders_active")
        p 車通勤OK
        input.text-box(type="text" v-model="jobDetail.car_commuting_ok")
        p バイク通勤OK
        input.text-box(type="text" v-model="jobDetail.bike_commuting_ok")
        p 転勤なし
        input.text-box(type="text" v-model="jobDetail.no_transfer")
        p 資格取得支援制度あり
        input.text-box(type="text" v-model="jobDetail.qualification_support_available")
        p 髭(ひげ)OK
        input.text-box(type="text" v-model="jobDetail.beard_ok")
        p ネイルOK
        input.text-box(type="text" v-model="jobDetail.nail_ok")
        p ピアスOK
        input.text-box(type="text" v-model="jobDetail.piercing_ok")
        p 禁煙・分煙
        input.text-box(type="text" v-model="jobDetail.non_smoking")
        p 残業多め(月20時間以上)
        input.text-box(type="text" v-model="jobDetail.high_overtime")
        p WEB選考完結OK
        input.text-box(type="text" v-model="jobDetail.web_screening_ok")
        p WEB登録OK
        input.text-box(type="text" v-model="jobDetail.web_registration_ok")
        p 職種（表示用）
        input.text-box(type="text" v-model="jobDetail.jobtype_name")
      .modal-cover
</template>

<script>
import { mapGetters } from 'vuex'
import { api } from '../../libs/api'

export default {
    data () {
      return {
        jobDetail: {},
        isLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        checkedIds: 'job/checkedIds',
        showAi: 'job/showAi',
      }),
    },
    methods: {
      close () {
        this.$store.commit('job/hideAiModal')
      },
      async generateAiManuscript () {
        this.$store.commit('common/lockGlobal')
        try {
          this.isLoading = true
          this.jobDetail = await api.getAiManuscript(this.checkedIds)
        } catch (e) {
          await this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
          this.isLoading = false
        }
      },
      downloadCSV () {
        const labels = [
          '原稿選択区分',
          '応募受付先ID',
          '応募受付先名',
          '表示用応募先名',
          '未使用',
          'メモ',
          '仕事No',
          '業務名',
          '業務名補足',
          '働く場所コード',
          '働く場所(表示用)',
          '職種コード1',
          '職種コード2',
          '職種コード3',
          '有料職業紹介',
          '募集1_雇用形態',
          '募集1_職種1',
          '募集1_職種2',
          '募集1_職種3',
          '募集1_給与支払区分',
          '募集1_給与下限',
          '募集1_給与上限',
          '未使用',
          '募集1_固定残業制',
          '募集1_固定残業制 残業代 下限',
          '募集1_固定残業制 残業代 上限',
          '募集1_固定残業制 残業代に充当する労働時間数 下限',
          '募集1_固定残業制 残業代に充当する労働時間数 上限',
          '募集1_勤務開始時間1',
          '募集1_勤務終了時間1',
          '募集1_勤務開始時間2',
          '募集1_勤務終了時間2',
          '募集1_勤務開始時間3',
          '募集1_勤務終了時間3',
          '募集2_雇用形態',
          '募集2_職種1',
          '募集2_職種2',
          '募集2_職種3',
          '募集2_給与支払区分',
          '募集2_給与下限',
          '募集2_給与上限',
          '未使用',
          '募集2_固定残業制',
          '募集2_固定残業制 残業代 下限',
          '募集2_固定残業制 残業代 上限',
          '募集2_固定残業制 残業代に充当する労働時間数 下限',
          '募集2_固定残業制 残業代に充当する労働時間数 上限',
          '募集2_勤務開始時間1',
          '募集2_勤務終了時間1',
          '募集2_勤務開始時間2',
          '募集2_勤務終了時間2',
          '募集2_勤務開始時間3',
          '募集2_勤務終了時間3',
          '募集3_雇用形態',
          '募集3_職種1',
          '募集3_職種2',
          '募集3_職種3',
          '募集3_給与支払区分',
          '募集3_給与下限',
          '募集3_給与上限',
          '未使用',
          '募集3_固定残業制',
          '募集3_固定残業制 残業代 下限',
          '募集3_固定残業制 残業代 上限',
          '募集3_固定残業制 残業代に充当する労働時間数 下限',
          '募集3_固定残業制 残業代に充当する労働時間数 上限',
          '募集3_勤務開始時間1',
          '募集3_勤務終了時間1',
          '募集3_勤務開始時間2',
          '募集3_勤務終了時間2',
          '募集3_勤務開始時間3',
          '募集3_勤務終了時間3',
          '給与備考',
          '交通費支払区分',
          '交通費備考',
          '勤務時間帯フラグ 早朝',
          '勤務時間帯フラグ 朝',
          '勤務時間帯フラグ 昼',
          '勤務時間帯フラグ 夕',
          '勤務時間帯フラグ 夜',
          '勤務時間帯フラグ 深夜',
          '勤務時間備考',
          '勤務地ロケーションID',
          '勤務地ロケーション名',
          '面接地ロケーションID',
          '面接地ロケーション名',
          '検索対象ロケーション',
          '採用予定人数',
          '未使用',
          '未使用',
          'Happyボーナス',
          'Happyボーナス支払条件',
          '動画1ファイル名',
          '動画1タイトル',
          '動画1コメント',
          '大画像ファイル名',
          '写真ファイル名',
          '写真1コメント',
          '写真2ファイル名',
          '写真2コメント',
          '写真3ファイル名',
          '写真3コメント',
          '制服写真1ファイル名',
          '制服写真1コメント',
          '制服写真2ファイル名',
          '制服写真2コメント',
          '制服写真3ファイル名',
          '制服写真3コメント',
          '制服写真4ファイル名',
          '制服写真4コメント',
          '制服写真5ファイル名',
          '制服写真5コメント',
          '制服写真6ファイル名',
          '制服写真6コメント',
          '制服写真7ファイル名',
          '制服写真7コメント',
          '制服写真8ファイル名',
          '制服写真8コメント',
          '制服写真9ファイル名',
          '制服写真9コメント',
          '職場写真1ファイル名',
          '職場写真1コメント',
          '職場写真2ファイル名',
          '職場写真2コメント',
          '職場写真3ファイル名',
          '職場写真3コメント',
          '職場写真4ファイル名',
          '職場写真4コメント',
          '職場写真5ファイル名',
          '職場写真5コメント',
          '職場写真6ファイル名',
          '職場写真6コメント',
          'アピールポイント_タイトル',
          'アピールポイント_内容',
          '仕事内容',
          'NEXT検索_活かせる持ち味_考え方のスタイル',
          'NEXT検索_活かせる持ち味_仕事の取り組み方',
          'NEXT検索_活かせる持ち味_仕事のこだわり',
          'NEXT検索_活かせる持ち味_人との接し方',
          'NEXT検索_特に活かせる持ち味',
          'NEXT検索_活かせる持ち味備考',
          '経験・資格',
          'NEXT用フリー項目1_タイトル',
          'NEXT用フリー項目1_内容',
          'NEXT用フリー項目2_タイトル',
          'NEXT用フリー項目2_内容',
          '休日・休暇(日曜日)',
          '休日・休暇(月曜日)',
          '休日・休暇(火曜日)',
          '休日・休暇(水曜日)',
          '休日・休暇(木曜日)',
          '休日・休暇(金曜日)',
          '休日・休暇(土曜日)',
          '休日・休暇(祝日)',
          '休日・休暇(完全週休2日)',
          '休日・休暇(交代制)',
          '休日・休暇備考',
          '勤務期間区分',
          '勤務期間備考',
          '勤務開始日',
          '待遇・福利厚生',
          '社員登用あり',
          '社員登用_こんな人が社員になっています!(人物像)',
          '社員登用_こんな人を社員にしたいです!(人物像)',
          '社員登用_直近1年の社員登用実績',
          '社員登用_社員登用時期の目安',
          '社員登用_社員登用後の仕事内容',
          '社員登用_社員登用後の待遇',
          'シフト自由・相談OK',
          'シフト提出(月毎)',
          'シフト提出(1~2週毎)',
          '週1日からOK',
          '週2〜3日からOK',
          '週4日以上OK',
          '1日1・2時間以内OK',
          '1日4時間以内(短時間)OK',
          '1日6時間以内OK',
          '9時以降勤務開始OK',
          '10時以降勤務開始OK',
          '16時前退社OK',
          '17時前退社OK',
          '土日祝休み',
          '土日祝(週末)のみOK',
          '完全週休二日制',
          '家庭や子供の用事でお休み調整可',
          '春休み・夏休み・冬休み期間限定',
          '残業なし',
          '残業少なめ(月20時間未満)',
          '残業多め(月20時間以上)',
          '未使用',
          '高収入・高額・高給',
          '在宅ワーク・内職',
          '扶養控除内OK',
          '給与手渡しOK',
          '給与前払いOK',
          '給与UP',
          '昇給あり',
          '未経験・初心者歓迎',
          '主婦(ママ)・主夫歓迎',
          '学生歓迎',
          '高校生歓迎',
          '新卒・第二新卒歓迎',
          'フリーター歓迎',
          'ミドル(40代〜)活躍中',
          'シニア(60代〜)歓迎',
          '外国人活躍中・留学生歓迎',
          '学歴(中卒・高卒)不問',
          '副業・WワークOK',
          'ブランク有OK',
          '経験者優遇',
          'オープニングスタッフ',
          '駅から徒歩5分以内',
          '産休・育休取得実績あり',
          '未使用',
          'リゾート',
          '交通費支給',
          '寮・社宅あり(住み込み)',
          '託児所あり',
          '社会保険制度あり',
          'まかない・食事補助',
          '研修制度あり',
          '髪型・髪色自由',
          '未使用',
          '服装自由',
          '履歴書不要',
          '友達と一緒に応募OK',
          '正社員経験不問',
          '職種未経験OK',
          '資格・スキル身につく',
          '将来は独立',
          '待遇福利厚生が充実',
          '女性活躍中',
          'NEXT検索_社風_会社のスタイル',
          'NEXT検索_社風_働き方のスタイル',
          'NEXT検索_社風_評価基準',
          'NEXT検索_社風_会社の雰囲気',
          'NEXT検索_特にアピールしたい社風',
          'NEXT検索_社風備考',
          '職場環境_年齢層_10代',
          '職場環境_年齢層_20代',
          '職場環境_年齢層_30代',
          '職場環境_年齢層_40代',
          '職場環境_年齢層_50代',
          '職場環境_男女の割合',
          '職場環境_仕事の仕方',
          '職場環境_職場の様子',
          '雰囲気_業務外交流',
          '雰囲気_働くスタイル',
          '雰囲気_働く場所',
          '雰囲気_お客様との対話',
          '雰囲気_力仕事',
          '雰囲気_経験・知識',
          '社風・雰囲気_備考',
          '未使用',
          '未使用',
          '未使用',
          '未使用',
          '未使用',
          '未使用',
          '未使用',
          '未使用',
          'しごと体験・職場見学選択',
          '職場見学_見学時間(時間)',
          '職場見学_見学時間(分)',
          '職場見学_見学内容と当日の流れ',
          'しごと体験_体験時間(時間)',
          'しごと体験_体験時間(分)',
          'しごと体験_給与金額',
          'しごと体験_体験内容と当日の流れ',
          '時間固定シフト制',
          '日払いOK',
          '週払いOK',
          'エルダー(50代〜)活躍中',
          '車通勤OK',
          'バイク通勤OK',
          '転勤なし',
          '資格取得支援制度あり',
          '髭(ひげ)OK',
          'ネイルOK',
          'ピアスOK',
          '禁煙・分煙',
          'dipさんからのメッセージ',
          'dipさんからのメッセージ_内容',
          'WEB選考完結OK',
          'WEB登録OK',
          '動画2ファイル名',
          '動画2タイトル',
          '動画2コメント',
          '動画3ファイル名',
          '動画3タイトル',
          '動画3コメント',
          '応募者の生年月日',
          'Indeed PLUSの掲載',
          '職種（表示用）',
          '試用期間',
          '試用期間の給与支払区分',
          '試用期間の給与下限',
          '試用期間の給与上限',
          '試用期間の想定労働時間',
          '試用期間の労働条件',
          '試用期間の固定残業制',
          '試用期間の固定残業制 残業代 下限',
          '試用期間の固定残業制 残業代 上限',
          '試用期間の固定残業制 残業代に充当する労働時間数 下限',
          '試用期間の固定残業制 残業代に充当する労働時間数 上限',
          '想定労働時間',
        ]
        const keys = [
          '', // 原稿選択区分
          '', // 応募受付先ID
          '', // 応募受付先名
          '', // 表示用応募先名
          '', // 未使用
          '', // メモ
          'job_id', // 仕事No
          'jobtype_name', // 業務名
          'jobname_detail', // 業務名補足
          '', // 働く場所コード
          'work_place', // 働く場所(表示用)
          '', // 職種コード1
          '', // 職種コード2
          '', // 職種コード3
          '', // 有料職業紹介
          'employment_name', // 募集1_雇用形態
          '', // 募集1_職種1
          '', // 募集1_職種2
          '', // 募集1_職種3
          '', // 募集1_給与支払区分
          'salary_min', // 募集1_給与下限
          'salary_max', // 募集1_給与上限
          '', // 未使用
          'fixed_overtime', // 募集1_固定残業制
          '', // 募集1_固定残業制 残業代 下限
          '', // 募集1_固定残業制 残業代 上限
          '', // 募集1_固定残業制 残業代に充当する労働時間数 下限
          '', // 募集1_固定残業制 残業代に充当する労働時間数 上限
          'shift1_start', // 募集1_勤務開始時間1
          'shift1_end', // 募集1_勤務終了時間1
          'shift2_start', // 募集1_勤務開始時間2
          'shift2_end', // 募集1_勤務終了時間2
          'shift3_start', // 募集1_勤務開始時間3
          'shift3_end', // 募集1_勤務終了時間3
          '', // 募集2_雇用形態
          '', // 募集2_職種1
          '', // 募集2_職種2
          '', // 募集2_職種3
          '', // 募集2_給与支払区分
          '', // 募集2_給与下限
          '', // 募集2_給与上限
          '', // 未使用
          '', // 募集2_固定残業制
          '', // 募集2_固定残業制 残業代 下限
          '', // 募集2_固定残業制 残業代 上限
          '', // 募集2_固定残業制 残業代に充当する労働時間数 下限
          '', // 募集2_固定残業制 残業代に充当する労働時間数 上限
          '', // 募集2_勤務開始時間1
          '', // 募集2_勤務終了時間1
          '', // 募集2_勤務開始時間2
          '', // 募集2_勤務終了時間2
          '', // 募集2_勤務開始時間3
          '', // 募集2_勤務終了時間3
          '', // 募集3_雇用形態
          '', // 募集3_職種1
          '', // 募集3_職種2
          '', // 募集3_職種3
          '', // 募集3_給与支払区分
          '', // 募集3_給与下限
          '', // 募集3_給与上限
          '', // 未使用
          '', // 募集3_固定残業制
          '', // 募集3_固定残業制 残業代 下限
          '', // 募集3_固定残業制 残業代 上限
          '', // 募集3_固定残業制 残業代に充当する労働時間数 下限
          '', // 募集3_固定残業制 残業代に充当する労働時間数 上限
          '', // 募集3_勤務開始時間1
          '', // 募集3_勤務終了時間1
          '', // 募集3_勤務開始時間2
          '', // 募集3_勤務終了時間2
          '', // 募集3_勤務開始時間3
          '', // 募集3_勤務終了時間3
          'salary_detail', // 給与備考
          '', // 交通費支払区分
          '', // 交通費備考
          'flag_early_morning', // 勤務時間帯フラグ 早朝
          'flag_morning', // 勤務時間帯フラグ 朝
          'flag_daytime', // 勤務時間帯フラグ 昼
          'flag_evening', // 勤務時間帯フラグ 夕
          'flag_night', // 勤務時間帯フラグ 夜
          'flag_midnight', // 勤務時間帯フラグ 深夜
          'shift_notes', // 勤務時間備考
          '', // 勤務地ロケーションID
          '', // 勤務地ロケーション名
          '', // 面接地ロケーションID
          '', // 面接地ロケーション名
          '', // 検索対象ロケーション
          'recruits', // 採用予定人数
          '', // 未使用
          '', // 未使用
          '', // Happyボーナス
          '', // Happyボーナス支払条件
          '', // 動画1ファイル名
          '', // 動画1タイトル
          '', // 動画1コメント
          '', // 大画像ファイル名
          '', // 写真ファイル名
          '', // 写真1コメント
          '', // 写真2ファイル名
          '', // 写真2コメント
          '', // 写真3ファイル名
          '', // 写真3コメント
          '', // 制服写真1ファイル名
          '', // 制服写真1コメント
          '', // 制服写真2ファイル名
          '', // 制服写真2コメント
          '', // 制服写真3ファイル名
          '', // 制服写真3コメント
          '', // 制服写真4ファイル名
          '', // 制服写真4コメント
          '', // 制服写真5ファイル名
          '', // 制服写真5コメント
          '', // 制服写真6ファイル名
          '', // 制服写真6コメント
          '', // 制服写真7ファイル名
          '', // 制服写真7コメント
          '', // 制服写真8ファイル名
          '', // 制服写真8コメント
          '', // 制服写真9ファイル名
          '', // 制服写真9コメント
          '', // 職場写真1ファイル名
          '', // 職場写真1コメント
          '', // 職場写真2ファイル名
          '', // 職場写真2コメント
          '', // 職場写真3ファイル名
          '', // 職場写真3コメント
          '', // 職場写真4ファイル名
          '', // 職場写真4コメント
          '', // 職場写真5ファイル名
          '', // 職場写真5コメント
          '', // 職場写真6ファイル名
          '', // 職場写真6コメント
          'appeal_point_title', // アピールポイント_タイトル
          'appeal_point_content', // アピールポイント_内容
          'job_contents', // 仕事内容
          '', // NEXT検索_活かせる持ち味_考え方のスタイル
          '', // NEXT検索_活かせる持ち味_仕事の取り組み方
          '', // NEXT検索_活かせる持ち味_仕事のこだわり
          '', // NEXT検索_活かせる持ち味_人との接し方
          '', // NEXT検索_特に活かせる持ち味
          '', // NEXT検索_活かせる持ち味備考
          'requestment', // 経験・資格
          '', // NEXT用フリー項目1_タイトル
          '', // NEXT用フリー項目1_内容
          '', // NEXT用フリー項目2_タイトル
          '', // NEXT用フリー項目2_内容
          'holiday_sunday', // 休日・休暇(日曜日)
          'holiday_monday', // 休日・休暇(月曜日)
          'holiday_tuesday', // 休日・休暇(火曜日)
          'holiday_wednesday', // 休日・休暇(水曜日)
          'holiday_thursday', // 休日・休暇(木曜日)
          'holiday_friday', // 休日・休暇(金曜日)
          'holiday_saturday', // 休日・休暇(土曜日)
          'holiday_holiday', // 休日・休暇(祝日)
          'holiday_full_weekend', // 休日・休暇(完全週休2日)
          'holiday_shift', // 休日・休暇(交代制)
          'holiday_notes', // 休日・休暇備考
          '', // 勤務期間区分
          'working_period_notes', // 勤務期間備考
          '', // 勤務開始日
          'benefits', // 待遇・福利厚生
          'employee_promotion_available', // 社員登用あり
          '', // 社員登用_こんな人が社員になっています!(人物像)
          '', // 社員登用_こんな人を社員にしたいです!(人物像)
          '', // 社員登用_直近1年の社員登用実績
          '', // 社員登用_社員登用時期の目安
          '', // 社員登用_社員登用後の仕事内容
          '', // 社員登用_社員登用後の待遇
          'flexible_shift', // シフト自由・相談OK
          'shift_submission_monthly', // シフト提出(月毎)
          'shift_submission_biweekly', // シフト提出(1~2週毎)
          'one_day_per_week_ok', // 週1日からOK
          'two_to_three_days_per_week_ok', // 週2〜3日からOK
          'four_or_more_days_per_week_ok', // 週4日以上OK
          'one_to_two_hours_per_day_ok', // 1日1・2時間以内OK
          'up_to_four_hours_per_day_ok', // 1日4時間以内(短時間)OK
          'up_to_six_hours_per_day_ok', // 1日6時間以内OK
          'start_after_9am', // 9時以降勤務開始OK
          'start_after_10am', // 10時以降勤務開始OK
          'leave_before_4pm', // 16時前退社OK
          'leave_before_5pm', // 17時前退社OK
          'weekends_holidays_off', // 土日祝休み
          'weekends_only_ok', // 土日祝(週末)のみOK
          'full_two_day_off', // 完全週休二日制
          'family_responsibilities_flexible', // 家庭や子供の用事でお休み調整可
          'seasonal_holiday_only', // 春休み・夏休み・冬休み期間限定
          'no_overtime', // 残業なし
          'low_overtime', // 残業少なめ(月20時間未満)
          'high_overtime', // 残業多め(月20時間以上)
          '', // 未使用
          'high_income', // 高収入・高額・高給
          'remote_work', // 在宅ワーク・内職
          'within_tax_deduction_ok', // 扶養控除内OK
          'cash_payment_ok', // 給与手渡しOK
          'advance_payment_ok', // 給与前払いOK
          'salary_increase', // 給与UP
          'salary_raise_available', // 昇給あり
          'no_experience_required', // 未経験・初心者歓迎
          'housewives_househusbands_welcome', // 主婦(ママ)・主夫歓迎
          'students_welcome', // 学生歓迎
          'highschool_students_welcome', // 高校生歓迎
          'fresh_graduates_welcome', // 新卒・第二新卒歓迎
          'freeters_welcome', // フリーター歓迎
          'middle_aged_active', // ミドル(40代〜)活躍中
          'seniors_welcome', // シニア(60代〜)歓迎
          'foreigners_students_welcome', // 外国人活躍中・留学生歓迎
          'no_academic_requirement', // 学歴(中卒・高卒)不問
          'side_job_ok', // 副業・WワークOK
          'career_gap_ok', // ブランク有OK
          'experienced_preferred', // 経験者優遇
          'opening_staff', // オープニングスタッフ
          'station_within_5_minutes', // 駅から徒歩5分以内
          'maternity_paternity_leave_available', // 産休・育休取得実績あり
          '', // 未使用
          'resort', // リゾート
          'transportation_provided', // 交通費支給
          'dormitory_provided', // 寮・社宅あり(住み込み)
          'daycare_available', // 託児所あり
          'social_insurance', // 社会保険制度あり
          'meal_support', // まかない・食事補助
          'training_available', // 研修制度あり
          'free_hair_style', // 髪型・髪色自由
          '', // 未使用
          'clothing_free', // 服装自由
          'no_resume_required', // 履歴書不要
          'apply_with_friends_ok', // 友達と一緒に応募OK
          'no_full_time_experience_required', // 正社員経験不問
          'no_job_experience_required', // 職種未経験OK
          'gain_qualification_skills', // 資格・スキル身につく
          'future_independence', // 将来は独立
          'excellent_benefits', // 待遇福利厚生が充実
          'women_active', // 女性活躍中
          '', // NEXT検索_社風_会社のスタイル
          '', // NEXT検索_社風_働き方のスタイル
          '', // NEXT検索_社風_評価基準
          '', // NEXT検索_社風_会社の雰囲気
          '', // NEXT検索_特にアピールしたい社風
          '', // NEXT検索_社風備考
          'age_group_teens', // 職場環境_年齢層_10代
          'age_group_20s', // 職場環境_年齢層_20代
          'age_group_30s', // 職場環境_年齢層_30代
          'age_group_40s', // 職場環境_年齢層_40代
          'age_group_50s', // 職場環境_年齢層_50代
          '', // 職場環境_男女の割合
          '', // 職場環境_仕事の仕方
          '', // 職場環境_職場の様子
          '', // 雰囲気_業務外交流
          '', // 雰囲気_働くスタイル
          '', // 雰囲気_働く場所
          '', // 雰囲気_お客様との対話
          '', // 雰囲気_力仕事
          '', // 雰囲気_経験・知識
          '', // 社風・雰囲気_備考
          '', // 未使用
          '', // 未使用
          '', // 未使用
          '', // 未使用
          '', // 未使用
          '', // 未使用
          '', // 未使用
          '', // 未使用
          '', // しごと体験・職場見学選択
          '', // 職場見学_見学時間(時間)
          '', // 職場見学_見学時間(分)
          '', // 職場見学_見学内容と当日の流れ
          '', // しごと体験_体験時間(時間)
          '', // しごと体験_体験時間(分)
          '', // しごと体験_給与金額
          '', // しごと体験_体験内容と当日の流れ
          'fixed_time_shift', // 時間固定シフト制
          'daily_pay_ok', // 日払いOK
          'weekly_pay_ok', // 週払いOK
          'elders_active', // エルダー(50代〜)活躍中
          'car_commuting_ok', // 車通勤OK
          'bike_commuting_ok', // バイク通勤OK
          'no_transfer', // 転勤なし
          'qualification_support_available', // 資格取得支援制度あり
          'beard_ok', // 髭(ひげ)OK
          'nail_ok', // ネイルOK
          'piercing_ok', // ピアスOK
          'non_smoking', // 禁煙・分煙
          '', // dipさんからのメッセージ
          '', // dipさんからのメッセージ_内容
          'web_screening_ok', // WEB選考完結OK
          'web_registration_ok', // WEB登録OK
          '', // 動画2ファイル名
          '', // 動画2タイトル
          '', // 動画2コメント
          '', // 動画3ファイル名
          '', // 動画3タイトル
          '', // 動画3コメント
          '', // 応募者の生年月日
          '', // Indeed PLUSの掲載
          '', // 職種（表示用）
          '', // 試用期間
          '', // 試用期間の給与支払区分
          '', // 試用期間の給与下限
          '', // 試用期間の給与上限
          '', // 試用期間の想定労働時間
          '', // 試用期間の労働条件
          '', // 試用期間の固定残業制
          '', // 試用期間の固定残業制 残業代 下限
          '', // 試用期間の固定残業制 残業代 上限
          '', // 試用期間の固定残業制 残業代に充当する労働時間数 下限
          '', // 試用期間の固定残業制 残業代に充当する労働時間数 上限
          '', // 想定労働時間
        ]

        const hasValue = keys.some((key) => {
          const val = this.jobDetail[key]
          return val !== null && val !== undefined && String(val).trim() !== ''
        })

        if (!hasValue) {
          this.$store.dispatch('common/pushToastError', {
            error: new Error('原稿が生成されておりません。1つ以上の項目に入力が必要です。'),
          })
          return
        }

        const rows = labels.map(label => `"${label.replace(/"/g, '""')}"`).join(',')
        const valueRow = keys.map((key) => {
          const val = key ? this.jobDetail[key] : ''
          return `"${String(val || '').replace(/"/g, '""')}"`
        }).join(',')

        const csvContent = `\uFEFF${rows}\n${valueRow}`
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', 'ai_job_detail.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobAiManuscriptModal.vue